export default __webpack_public_path__ + "static/media/23322.79ed627a.jpg";